// components/forms/NewsletterFormComponent.jsx

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import DataProtectionInformationContactForm from './DataProtectionInformationContactForm';

const NewsletterFormComponent = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: '',
    acceptPrivacyPolicy: false,
  });
  const [submitted, setSubmitted] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.acceptPrivacyPolicy) {
      alert(t('must_accept_privacy_policy'));
      return;
    }

    try {
      await axios.post(`${apiUrl}/newsletter/subscribe`, { email: formData.email });
      setSubmitted(true);
    } catch (err) {
      console.error('Newsletter subscription error:', err);
      alert(t('subscription_error'));
    }
  };

  return (
    <div className="web-modal-form">
      {submitted ? (
        <div style={{ textAlign: 'center' }}>
          <h2>{t('thank_you')}</h2>
          <p>{t('confirmation_email_sent')}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <h2 style={{ textAlign: 'center', marginBottom: '1rem', color: 'var(--green-darkest)' }}>
            {t('subscribe_to_newsletter')}
          </h2>

          <label className="web-modal-text-muted">{t('your_email')}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="web-modal-input"
          />
          
          <DataProtectionInformationContactForm
            formData={formData}
            handleChange={handleChange}
            fontSize="0.8em"
          />

          <button
            type="submit"
            className="web-modal-button"
            style={{ width: '100%', marginTop: '1rem' }}
          >
            {t('subscribe')}
          </button>
        </form>
      )}
    </div>
  );
};

export default NewsletterFormComponent;